// jQuery Whaaaaaat?
// import $ from 'jquery';
// window.$ = window.jQuery = $;
// console.log('jQuery loaded:', !!window.jQuery);

// import clicks etc. events.js (note: jquery is imported in there, so it has to be first )
import './dependencies/events-main.js';

import './dependencies/jquery.are-you-sure.js';
console.log('areYouSure loaded:', !!$.fn.areYouSure);

import 'jquery.mmenu.4.7.5/src/js/jquery.mmenu.min.all.js';
import { initMenu } from './dependencies/initMenu.js';
console.log('mmenu loaded:', !!$.fn.mmenu);
// initialize the mmenu /////////////////////////
initMenu();

import select2 from 'select2';
select2();
console.log('select2 loaded:', !!$.fn.select2);

import DataTable from 'datatables.net-bs4';
console.log('DataTables loaded:', !!$.fn.DataTable);
import 'datatables.net-buttons-bs4';
import 'datatables.net-responsive-bs4';

// Import all of Bootstrap’s JS
import * as bootstrap from 'bootstrap'
// check for bootstrap dropdown functionality
console.log('Bootstrap loaded:', !!bootstrap.Dropdown);

// import validate
import 'jquery-validation';
import 'jquery-validation/dist/additional-methods.js';
console.log('jQuery Validate loaded:', !!$.fn.validate);

// import scenario initializer
import { initScenario } from './components/scenario/init.js'
console.log('initScenario loaded:', !!initScenario);

// initialize scenario stuff
// console.log("Zone:", window.zone);
// some variables apply to scenario "page" only
// if zone is defined, we are on a scenario page
if (typeof window.zone !== 'undefined') {
    initScenario();
}

/// init admin. spreader tables etc.
import { initAdmin } from './components/admin/init.js'
console.log('initAdmin loaded:', !!initAdmin);
////
initAdmin();

import { mountSoilTest } from './components/soiltest/init.js';
if (document.getElementById('soil-testing-app')) {
  mountSoilTest();
}



$("#toggle-hints").attr("checked", false);

if ($('#save-scenario').length) {
    $('#save-scenario').areYouSure({'addRemoveFieldsMarksDirty': true});
}


//// WEEKS DISPLAY //////////////////////////
if ( !localStorage.weeksDisplay) {
  localStorage.weeksDisplay = 'week-numbers'
} else {
  var val = localStorage.weeksDisplay;
  $('input[name="weeks-display"][value="'+val+'"]').attr("checked", true);
}

//// init the selects ///////////////////////////

/// tip for adding links to dropdown items
////http://jsfiddle.net/f8q2by55/

$('.select-two-skinny').select2({
    width: 'auto',
    minimumResultsForSearch: 99999
});

$('.select-two-skinny-zone').select2({
    width: '100px',
    minimumResultsForSearch: 99999
});

$('.select-two-carryover').select2({
    dropdownParent: $('#carryOverModal')
});

$('.spreader-product-select').select2({
    width: '100%',
});

$('.select-two-no-search').select2({
    width: '100%',
    minimumResultsForSearch: 99999
});

$('.select-two-no-search-half').select2({
    width: '50%',
    minimumResultsForSearch: 99999
});

$('.target-select').select2({
    width: '100%',
    minimumResultsForSearch: 99999,
    templateSelection: function (data) {
        return data.text;
    },
    "language": {
        "noResults": function () {
            return "Select Units First";
        }
    }
});

$('.zone-select').select2({
    width: '100%',
    minimumResultsForSearch: 99999,
    templateSelection: function (data) {
        return data.text;
    },
    "language": {
        "noResults": function () {
            return "Select Country First";
        }
    }
});

//////////////////////////// FORM VALIDATION ///////////////////////


// // method for excluding slashes
  $.validator.addMethod("stripspecialchars", function(value, element) {
    return this.optional(element) || !(/\//g.test(value));
    });


  $("#new-scenario").validate({
    rules: {
      "title": {
        required: true,
        stripspecialchars: true
      },
      "fields[turfAcres]": "required",
      "fields[turfType]": "required",
      "fields[country]": "required",
      "fields[units]": "required",
      "fields[targetNitrogen]": "required",
      "zone-select": "required"
    },
    messages: {
      "title": {
        required: "is required.",
        stripspecialchars: "Sorry, no slashes in titles."
      },
      "fields[turfAcres]": "is required.",
      "fields[turfType]": "is required.",
      "fields[country]": "is required.",
      "fields[units]": "is required",
      "fields[targetNitrogen]": "is required.",
      "zone-select": "is required."
    },
    errorPlacement: function(error, element) {
      var label = $(element).prev()
      error.insertAfter(label);
    },
    success: function(success, element){
      console.log("hello success");
    },
    submitHandler: function(form) {

      console.log("SAVING...")
      $('.btn-save').addClass('disabled')
      $('.btn-save span').text('Saving...')
      $('.btn-save i').removeClass('fa-save').addClass('fa-spinner fa-spin')
      $('.date-saved').hide()

      // this didn't work with a really generic form
      // held over from a guest entry with image form
      //var theform = $('#save-scenario');
      //var formData = new FormData(theform);

      // so... we simply serialize

      var formData = $(form).serialize();
      //const honeypot = document.querySelector('[name="contact_me_by_fax_only"]');

      //if (honeypot.value == "0"){
        $.ajax({
          method: "POST",
          dataType:"json",
          headers: {
            Accept: "application/json"
          },
          data: formData,
          error: function(data, response) {
            // HANDLE ERRORS HERE
            console.log("ERROR: " + response)
          },
          success: function(data, response){
            //DO SOMETHING AFTER AJAX REQUEST SUCCEEDS
            console.log("SUCCES!")
            window.location.replace("/scenario/"+data.id);
          }
        });
      //}

    } // end submithandler
  });

  // FOR THE SAVE etc. /////////////////////

  $("#save-scenario").validate({
    rules: {
      "title": {
            required: true,
            stripspecialchars: true
          },
      "fields[coverage]": "required"
    },
    messages: {
      "title": {
        required: "A title is required.",
        stripspecialchars: "Sorry, no slashes in titles."
        },
      "fields[coverage]": "is required."
    },
    errorPlacement: function(error, element) {
      var name = element.attr('name');
      console.log(name);
      if ( name == 'title' ) {
              $('#title-error').html(error.html());
      } else {
        error.insertAfter(element);
      }
    },
    success: function(success, element){},
    submitHandler: function(form) {
      console.log("SAVING SCENARIO...")
      //$('.spinner').show()
      $('.btn-save').addClass('disabled')
      $('.btn-save span').text('Saving Scenario...')
      $('.btn-save i').removeClass('fa-save').addClass('fa-spinner fa-spin')
      $('.date-saved').hide()

      // this didn't work with a really generic form
      // held over from a guest entry with image form
      //var theform = $('#save-scenario');
      //var formData = new FormData(theform);

      // so... we simply serialize

      var formData = $(form).serialize();
      //const honeypot = document.querySelector('[name="contact_me_by_fax_only"]');

      //if (honeypot.value == "0"){
        $.ajax({
          method: "POST",
          dataType:"json",
          headers: {
            Accept: "application/json"
          },
          data: formData,
          error: function(data, response) {
            // HANDLE ERRORS HERE
            console.log("ERROR: " + response)
          },
          success: function(data, response){
            //DO SOMETHING AFTER AJAX REQUEST SUCCEEDS
            console.log("SUCCESS!")
            //$('.spinner').hide()
            $('.btn-save').removeClass('disabled')
            $('.btn-save span').text('Save Scenario')
            $('.btn-save i').removeClass('fa-spinner fa-spin').addClass('fa-save')
            const now = new Date();
            const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true };
            const formattedDate = now.toLocaleString('en-US', options);
            $('.date-saved').html('Last saved ' + formattedDate).show()
            $('.btn-save').blur()
          }
        });
      //}
    } // end submithandler
  });

 ////////////////////////////////////. FEATURE: sortable, paginated table ///////////////////////

  var userScenariosTableDT = new DataTable('#user-scenarios-table', {
    "info": true,
    "paging": true,
    "searching": true,
    "dom": 'Bfrtlip',
    // layout: {
    //     topStart: 'buttons',
    //     topEnd: 'search'
    // },
    buttons: [
        {
            className: 'btn btn-primary btn-new-scenario',
            text: '<i class="fas fa-plus"></i>New Scenario',
            action: function ( e, dt, node, config ) {
                //alert( 'Button activated' );
                window.location.href = "/scenario/new"
            }
        }
    ],
    "drawCallback": function( settings ) {
      var api = this.api();
      // Initialize custom controls. Select2.
      //initCountCtrl(api.table().container());
    },
    "language": {
      "lengthMenu": "Display _MENU_"
    },
    order: [],
    columnDefs: [
            {
                targets: 1,
                data: {
                    _: "1.display",
                    sort: "1.@data-order",
                    type: "1.@data-order"
                }
            },
            {
              targets: [ 1, 8, 9 ],
              orderable: false
            }
        ]
  });




/// STICKY AD STUFF

// scan the elements
var elements = $( ".sticky-container, li.ads" ).toArray();
var ads = [];


//troll the hiddens and if not hidden, show
for(var i=0; i < elements.length; i++) {
var id = $(elements[i]).attr('id');
if ( sessionStorage.hideads ) {
    ads = JSON.parse(sessionStorage.hideads);
}
var state = $.inArray(id, ads);
//console.log(id);

if (state=="-1") {
    // absent, show it
    $('#'+id+'.sticky-container').show();
    $('li#'+id+'.ads').show();
}
}

if ( sessionStorage.hideads ) {
ads = JSON.parse(sessionStorage.hideads);
for(var i=0; i < ads.length; i++) {
    var id = ads[i];
    $('#'+id+'.sticky-container').hide();
    $('li#'+id+'.ads').hide();
}
}

$('.sticky-close').click(function(){
var id = $(this).data('id');
var ads = [];
if ( sessionStorage.hideads ) {
    ads = JSON.parse(sessionStorage.hideads);
}
var state = $.inArray(id, ads);
if (state=="-1") {
    // absent, add it
    ads.push(id);
    sessionStorage.hideads = JSON.stringify(ads);
}
$('#'+id+'.sticky-container').hide();
});

$('.sticky-close-sidebar').click(function(){
var id = $(this).data('id');
var ads = [];
if ( sessionStorage.hideads ) {
    ads = JSON.parse(sessionStorage.hideads);
}
var state = $.inArray(id, ads);
if (state=="-1") {
    // absent, add it
    ads.push(id);
    sessionStorage.hideads = JSON.stringify(ads);
}
$('li#'+id+'.ads').hide();
});	

////////////////// TEMPORARY SCRIPT. CAREFUL.
setTimeout(function(){ 
//$("#save-scenario").submit()
}, 3000);











console.log("main.js fully loaded");







 
